(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // custom js
  document.querySelector('.header__icon.menu-drawer-close-btn')
  ?.addEventListener('click', function () {
    const menuSummary = document.querySelector(
      'header-drawer summary.header__icon.header__icon--menu.header__icon--summary'
    );

    if (menuSummary) {
      menuSummary.click();
    }
  });

  function updateMenuDrawerHeight() {
      const custom_announcement_bar = document.querySelector('.announcement-bar-section');
      const customdrawer = document.querySelector('#menu-drawer');

      if (!custom_announcement_bar || !customdrawer) return;

      customdrawer.style.height = `calc(100vh - ${custom_announcement_bar.offsetHeight}px)`;
  }

  window.addEventListener('load', updateMenuDrawerHeight);
  window.addEventListener('resize', updateMenuDrawerHeight);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const items = Array.from(document.querySelectorAll(".pfeatures-item"));
  const colorImgs = Array.from(document.querySelectorAll(".pfeatures-color-img"));
  const featureImgs = Array.from(document.querySelectorAll(".pfeatures-feature-img"));
  const colorDots = Array.from(document.querySelectorAll(".pfeatures-color-dot"));
  const nextBtn = document.getElementById("pfeatures-next");
  const prevBtn = document.getElementById("pfeatures-prev");

  let currentIndex = 0; // 0 === Color Variations, 1..n === feature blocks
  let currentColor = 0;

  function clearActiveFromItems() {
    items.forEach(i => i.classList.remove("active"));
  }

  function clearActiveFromImages() {
    colorImgs.forEach(img => img.classList.remove("active"));
    featureImgs.forEach(img => img.classList.remove("active"));
  }

  function activateAccordion(index) {
    // normalize index to integer
    index = parseInt(index, 10);
    if (isNaN(index)) return;

    clearActiveFromItems();
    clearActiveFromImages();

    // Activate the corresponding accordion item
    const itemToActivate = items.find(i => parseInt(i.dataset.index, 10) === index);
    if (itemToActivate) itemToActivate.classList.add("active");

    if (index === 0) {
      // show the selected color image
      const colorImg = colorImgs.find(img => parseInt(img.dataset.color, 10) === parseInt(currentColor, 10));
      if (colorImg) colorImg.classList.add("active");
    } else {
      // show the feature image that matches this index
      const featureImg = featureImgs.find(img => parseInt(img.dataset.feature, 10) === index);
      if (featureImg && featureImg.getAttribute('src')) {
        featureImg.classList.add("active");
      } else {
        // if image missing (blank source), do nothing (no image visible)
      }
    }

    currentIndex = index;
  }

  // Wire up accordion click handlers
  items.forEach((item) => {
    item.addEventListener("click", () => {
      const idx = parseInt(item.getAttribute("data-index"), 10);
      activateAccordion(idx);
    });
  });

  nextBtn?.addEventListener("click", () => {
    // compute next index with wrap. items' data-index values start at 0 (colors) then 1..n
    const indexes = items.map(i => parseInt(i.dataset.index, 10));
    const currentPos = indexes.indexOf(currentIndex);
    const nextPos = (currentPos + 1) % indexes.length;
    activateAccordion(indexes[nextPos]);
  });

  prevBtn?.addEventListener("click", () => {
    const indexes = items.map(i => parseInt(i.dataset.index, 10));
    const currentPos = indexes.indexOf(currentIndex);
    const prevPos = (currentPos - 1 + indexes.length) % indexes.length;
    activateAccordion(indexes[prevPos]);
  });

  // Color dot handlers
  colorDots.forEach(dot => {
    dot.addEventListener("click", () => {
      colorDots.forEach(d => d.classList.remove("active"));
      dot.classList.add("active");
      currentColor = parseInt(dot.getAttribute("data-color"), 10);

      if (currentIndex === 0) {
        clearActiveFromImages();
        const selected = colorImgs.find(img => parseInt(img.dataset.color, 10) === currentColor);
        if (selected) selected.classList.add("active");
      }
    });
  });

  // Initialize whatever is active on load
  if (colorImgs.length) {
    colorImgs.forEach(img => img.classList.remove("active"));
    const startColorImg = colorImgs.find(img => parseInt(img.dataset.color, 10) === currentColor) || colorImgs[0];
    if (startColorImg) startColorImg.classList.add("active");
  }

  // Ensure the first accordion item (colors) is active on load
  activateAccordion(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".pfeatures-item");
  const images = document.querySelectorAll(".pfeatures-image-area img");
  const colorDots = document.querySelectorAll(".pfeatures-color-dot");
  const nextBtn = document.getElementById("pfeatures-next");
  const prevBtn = document.getElementById("pfeatures-prev");
  let currentIndex = 0;
  let currentColor = 0;

  function activateAccordion(index) {
  items.forEach((item, i) => item.classList.toggle("active", i === index));
  images.forEach(img => img.classList.remove("active"));

  if (index === 0) {
    const colorImg = document.querySelector(`.pfeatures-color-img[data-color="${currentColor}"]`);
    if (colorImg) colorImg.classList.add("active");
  } else {
    const offset = document.querySelectorAll(".pfeatures-color-img").length; // 6 in your case
    const imgToActivate = images[index + (offset - 1)]; // dynamically handles future changes too
    if (imgToActivate) imgToActivate.classList.add("active");
  }

  currentIndex = index;
}


  items.forEach((item, index) => {
    item.addEventListener("click", () => activateAccordion(index));
  });

  nextBtn?.addEventListener("click", () => {
    let newIndex = (currentIndex + 1) % items.length;
    activateAccordion(newIndex);
  });

  prevBtn?.addEventListener("click", () => {
    let newIndex = (currentIndex - 1 + items.length) % items.length;
    activateAccordion(newIndex);
  });

  colorDots.forEach(dot => {
    dot.addEventListener("click", () => {
      colorDots.forEach(d => d.classList.remove("active"));
      dot.classList.add("active");
      currentColor = dot.getAttribute("data-color");

      if (currentIndex === 0) {
        images.forEach(img => img.classList.remove("active"));
        const selected = document.querySelector(`.pfeatures-color-img[data-color="${currentColor}"]`);
        if (selected) selected.classList.add("active");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
